import { render, staticRenderFns } from "./creditEvaluate.vue?vue&type=template&id=0afe5226&scoped=true"
import script from "./creditEvaluate.vue?vue&type=script&lang=js"
export * from "./creditEvaluate.vue?vue&type=script&lang=js"
import style0 from "./creditEvaluate.vue?vue&type=style&index=0&id=0afe5226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe5226",
  null
  
)

export default component.exports